import { createFileRoute } from "@tanstack/react-router"
import { SignupAgeRestrictedPage } from "@/pages/onboarding"

export const Route = createFileRoute("/onboarding/signup-age-restricted")({
	component: SignupAgeRestrictedPage,
})
